/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_UpgradeInputs */

const en_plan_upgrade = /** @type {(inputs: Plan_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade Plan`)
};

const es_plan_upgrade = /** @type {(inputs: Plan_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar plan`)
};

/**
* | output |
* | --- |
* | "Upgrade Plan" |
*
* @param {Plan_UpgradeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_upgrade = /** @type {((inputs?: Plan_UpgradeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_UpgradeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_upgrade(inputs)
	return en_plan_upgrade(inputs)
});